const ANIMATION_TRANSITION = 'background-color .3s ease-in-out';
const ANIMATION_BACKGROUND_COLOR = '#999'; // @odeniel el color de flash no puede ser como el selected que sino no se va ver (en el grid por ejemplo)
const ANIMATION_TIMEOUT = 400; // @odeniel el color de flash no puede ser como el selected que sino no se va ver (en el grid por ejemplo)
// para guardar los elementos animados
const wmAnim = new WeakMap();
const wmCancel = new WeakMap();

/**
 * Realiza una animación "flash" para que el usuario encuentre el elemento en la pagina.
 * Devuelve una promesa que resuelve cuando la animación ha acabado.
 *
 * @param {HTMLElement} elem el elemento a animar
 * @returns {promise<>}
 */

export function flash(elem) {
  return new Promise((resolve, reject) => {
    if (wmAnim.has(elem)) {
      const cancel = wmCancel.get(elem);
      if (!cancel) {
        // tenemos animation registrada pero sin cancel? No debería pasar
        reject('algo ha ido mal');
        return;
        // salimos
      }

      // cancel de la animation para volver a empezarla
      clearTimeout(cancel);
      wmCancel.delete(elem);
    } else {
      const { transition, backgroundColor } = window.getComputedStyle(elem);
      wmCancel.delete(elem);
      wmAnim.set(elem, { transition, backgroundColor });
    }

    window.requestAnimationFrame(() => {
      elem.style.transition = ANIMATION_TRANSITION;
      elem.style.backgroundColor = ANIMATION_BACKGROUND_COLOR;

      wmCancel.set(
        elem,
        setTimeout(
          () =>
            window.requestAnimationFrame(() => {
              const { transition, backgroundColor } = wmAnim.get(elem);
              // restaurar backgroundColor original
              elem.style.backgroundColor = backgroundColor;

              wmCancel.set(
                elem,
                setTimeout(() => {
                  // restaurar transition original
                  elem.style.transition = transition;
                  // limpiamos los WeakMap
                  window.requestAnimationFrame(() => {
                    wmAnim.delete(elem);
                    wmCancel.delete(elem);
                  });
                  resolve('');
                }, ANIMATION_TIMEOUT)
              );
            }),
          ANIMATION_TIMEOUT
        )
      );
    });
  });
}
